import { mapActions, mapState, mapMutations } from 'vuex';
import { pluralize } from '@/utils/strings';

export const archive = {
	data() {
		return {
			isArchiving: false,
			isBulkArchiving: false,
		};
	},
	computed: {
		...mapState('campaigns', ['bulk']),
	},
	methods: {
		...mapActions('campaigns', ['bulkArchiveCampaigns']),
		...mapMutations('campaigns', ['addAlert']),
		async handle(campaigns, message, loadingKey, modalIdPrefix) {
			this[loadingKey] = true;
			this.bulkArchiveCampaigns({ campaigns })
				.then(() => {
					this.addAlert({ message, type: 'success' });
				})
				.finally(() => {
					this[loadingKey] = false;
					this.$modal.hide(`${modalIdPrefix}-archive-modal`);
				});
		},
		archive() {
			const message = `The ${this.campaign.name} campaign was archived successfully.`;

			this.handle([this.campaign.id], message, 'isArchiving', this.campaign.id);
		},
		bulkArchive() {
			const count = this.bulk.length;
			const message = `Successfully archived ${count} ${pluralize('campaign', count)}.`;

			this.handle(this.bulk, message, 'isBulkArchiving', 'bulk');
		},
	},
};
